var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 366,
    height: 193,
    viewBox: "0 0 366 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M251.349 164.871C288.145 128.076 288.145 68.4187 251.349 31.6235C214.554 -5.1717 154.897 -5.1717 118.102 31.6235C81.3071 68.4187 81.3071 128.075 118.102 164.871C154.897 201.666 214.554 201.666 251.349 164.871Z",
    fill: "#F8641B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M239.602 153.124C269.91 122.817 269.91 73.6782 239.602 43.3705C209.294 13.0627 160.156 13.0627 129.848 43.3705C99.5402 73.6782 99.5403 122.817 129.848 153.124C160.156 183.432 209.294 183.432 239.602 153.124Z",
    fill: "#F8641B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5897 127.327C39.5397 127.327 32.7197 120.507 32.7197 105.557V59.5571C32.7197 56.2771 34.1597 54.8371 37.4397 54.8371H57.7697C61.0397 54.8371 62.4897 56.2771 62.4897 59.5571V95.4271C62.4897 98.1771 64.0597 99.8771 66.5497 99.8771H78.7497V59.5371C78.7497 56.2571 80.1897 54.8171 83.4697 54.8171H103.66C106.94 54.8171 108.38 56.2571 108.38 59.5371V144.537C108.38 147.807 106.94 149.257 103.66 149.257H83.4697C80.1897 149.257 78.7497 147.807 78.7497 144.537V127.327H56.5897Z",
    fill: "#F8821B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M292.14 127.327C275.14 127.327 268.28 120.507 268.28 105.557V59.5571C268.28 56.2771 269.72 54.8371 273 54.8371H293.3C296.58 54.8371 298.02 56.2771 298.02 59.5571V95.4271C298.02 98.1771 299.6 99.8771 302.09 99.8771H314.3V59.5371C314.3 56.2571 315.75 54.8171 319.02 54.8171H339.22C342.49 54.8171 343.94 56.2571 343.94 59.5371V144.537C343.94 147.807 342.49 149.257 339.22 149.257H319.02C315.75 149.257 314.3 147.807 314.3 144.537V127.327H292.14Z",
    fill: "#F8821B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.16 51.007C251.95 19.507 273.53 -1.29304 275.3 0.306958C277.72 2.52696 240.82 47.357 192.81 100.477C144.8 153.597 103.88 194.817 101.42 192.597C99.7505 191.087 116.28 169.877 142.11 139.787C131.888 128.803 126.152 114.388 126.034 99.3835C125.916 84.3792 131.423 69.8751 141.471 58.7315C151.519 47.5878 165.378 40.6133 180.314 39.1834C195.251 37.7535 210.181 41.972 222.16 51.007ZM154.47 149.967C167.4 136.707 181.96 121.207 197.13 104.427C210.47 89.657 222.87 75.477 233.76 62.637C242.218 73.7924 246.509 87.5545 245.89 101.54C245.272 115.526 239.782 128.856 230.371 139.22C220.96 149.585 208.222 156.333 194.36 158.296C180.499 160.258 166.388 157.312 154.47 149.967Z",
    fill: "url(#paint0_linear_31_457)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M191.76 51.8271C193.52 56.5971 188.4 62.8271 180.32 65.8271C172.24 68.8271 164.3 67.4271 162.49 62.6571C160.68 57.8871 165.85 51.6571 173.93 48.6571C182.01 45.6571 190 47.0571 191.76 51.8271Z",
    fill: "#FFCC80"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150.72 75.247C153.371 75.247 155.52 73.0979 155.52 70.447C155.52 67.796 153.371 65.647 150.72 65.647C148.069 65.647 145.92 67.796 145.92 70.447C145.92 73.0979 148.069 75.247 150.72 75.247Z",
    fill: "#FFCC80"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M233.94 86.8471C235.266 86.8471 236.34 85.7726 236.34 84.4471C236.34 83.1216 235.266 82.0471 233.94 82.0471C232.615 82.0471 231.54 83.1216 231.54 84.4471C231.54 85.7726 232.615 86.8471 233.94 86.8471Z",
    fill: "#FFCC80"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M249.54 169.957C249.54 170.61 249.347 171.248 248.984 171.79C248.622 172.333 248.106 172.756 247.503 173.006C246.9 173.256 246.237 173.321 245.597 173.194C244.956 173.066 244.368 172.752 243.907 172.29C243.445 171.829 243.131 171.241 243.004 170.601C242.877 169.961 242.942 169.297 243.192 168.694C243.441 168.091 243.864 167.576 244.407 167.213C244.95 166.851 245.588 166.657 246.24 166.657C247.116 166.657 247.955 167.005 248.574 167.624C249.193 168.242 249.54 169.082 249.54 169.957Z",
    fill: "url(#paint1_linear_31_457)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9097 41.3169C79.2794 41.3169 80.3897 40.2066 80.3897 38.8369C80.3897 37.4673 79.2794 36.3569 77.9097 36.3569C76.54 36.3569 75.4297 37.4673 75.4297 38.8369C75.4297 40.2066 76.54 41.3169 77.9097 41.3169Z",
    fill: "url(#paint2_linear_31_457)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M365.51 109.577C365.51 109.884 365.419 110.183 365.249 110.438C365.079 110.693 364.837 110.892 364.553 111.009C364.27 111.126 363.958 111.157 363.658 111.097C363.357 111.037 363.081 110.89 362.864 110.673C362.647 110.456 362.5 110.18 362.44 109.879C362.38 109.579 362.411 109.267 362.528 108.984C362.645 108.701 362.844 108.459 363.099 108.288C363.354 108.118 363.654 108.027 363.96 108.027C364.37 108.03 364.763 108.194 365.053 108.484C365.343 108.774 365.508 109.167 365.51 109.577Z",
    fill: "url(#paint3_linear_31_457)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1 92.0471C3.1 92.3537 3.0091 92.6533 2.83878 92.9082C2.66846 93.1631 2.42639 93.3618 2.14316 93.4791C1.85993 93.5964 1.54828 93.6271 1.24761 93.5673C0.94694 93.5075 0.670756 93.3599 0.453985 93.1431C0.237213 92.9263 0.0895907 92.6502 0.0297836 92.3495C-0.0300235 92.0488 0.000671238 91.7372 0.117987 91.4539C0.235303 91.1707 0.433971 90.9286 0.688867 90.7583C0.943763 90.588 1.24344 90.4971 1.55 90.4971C1.75392 90.4958 1.95607 90.535 2.14473 90.6124C2.33338 90.6898 2.50478 90.8039 2.64898 90.9481C2.79317 91.0923 2.9073 91.2637 2.98472 91.4524C3.06214 91.641 3.10133 91.8432 3.1 92.0471Z",
    fill: "url(#paint4_linear_31_457)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M196.68 21.687C196.682 21.994 196.593 22.2946 196.424 22.5508C196.255 22.8071 196.013 23.0073 195.73 23.1261C195.447 23.245 195.135 23.2771 194.834 23.2184C194.532 23.1598 194.255 23.0129 194.038 22.7966C193.82 22.5802 193.671 22.304 193.611 22.0031C193.55 21.7022 193.58 21.39 193.697 21.1062C193.814 20.8224 194.013 20.5797 194.268 20.4089C194.523 20.2382 194.823 20.147 195.13 20.147C195.333 20.1457 195.534 20.1845 195.722 20.2613C195.91 20.3381 196.081 20.4514 196.225 20.5945C196.37 20.7376 196.484 20.9079 196.562 21.0954C196.64 21.2829 196.68 21.4839 196.68 21.687Z",
    fill: "url(#paint5_linear_31_457)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M275.09 26.4871C275.092 26.794 275.003 27.0947 274.834 27.3509C274.665 27.6071 274.423 27.8073 274.14 27.9262C273.857 28.045 273.545 28.0772 273.244 28.0185C272.943 27.9598 272.666 27.813 272.448 27.5966C272.23 27.3802 272.081 27.1041 272.021 26.8031C271.96 26.5022 271.99 26.19 272.107 25.9062C272.224 25.6224 272.423 25.3797 272.678 25.209C272.933 25.0382 273.233 24.9471 273.54 24.9471C273.743 24.9457 273.945 24.9846 274.133 25.0614C274.321 25.1382 274.492 25.2514 274.636 25.3946C274.78 25.5377 274.894 25.7079 274.972 25.8954C275.05 26.0829 275.09 26.284 275.09 26.4871Z",
    fill: "url(#paint6_linear_31_457)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M129.62 24.7371C129.618 25.3885 129.423 26.0247 129.06 26.5656C128.697 27.1065 128.182 27.528 127.58 27.7768C126.978 28.0256 126.316 28.0907 125.677 27.9638C125.038 27.837 124.451 27.5239 123.99 27.064C123.528 26.6041 123.213 26.0179 123.085 25.3794C122.956 24.7408 123.019 24.0785 123.266 23.4757C123.513 22.8729 123.933 22.3568 124.473 21.9922C125.012 21.6277 125.648 21.431 126.3 21.4271C126.735 21.4244 127.167 21.5082 127.571 21.6734C127.974 21.8387 128.341 22.0823 128.649 22.39C128.958 22.6978 129.203 23.0637 129.369 23.4665C129.536 23.8693 129.621 24.3012 129.62 24.7371Z",
    fill: "url(#paint7_linear_31_457)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72.76 170.557C72.76 170.883 72.6632 171.202 72.4819 171.474C72.3006 171.745 72.0429 171.957 71.7414 172.081C71.4399 172.206 71.1081 172.239 70.7881 172.175C70.468 172.112 70.174 171.954 69.9432 171.724C69.7125 171.493 69.5553 171.199 69.4917 170.879C69.428 170.559 69.4607 170.227 69.5856 169.926C69.7104 169.624 69.9219 169.366 70.1933 169.185C70.4646 169.004 70.7836 168.907 71.11 168.907C71.5476 168.907 71.9672 169.081 72.2767 169.39C72.5861 169.7 72.76 170.119 72.76 170.557Z",
    fill: "url(#paint8_linear_31_457)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M165.98 172.807C165.98 173.133 165.883 173.452 165.702 173.724C165.52 173.995 165.263 174.207 164.961 174.331C164.66 174.456 164.328 174.489 164.008 174.425C163.688 174.362 163.394 174.204 163.163 173.974C162.932 173.743 162.775 173.449 162.711 173.129C162.648 172.809 162.68 172.477 162.805 172.176C162.93 171.874 163.142 171.616 163.413 171.435C163.684 171.254 164.003 171.157 164.33 171.157C164.767 171.157 165.187 171.331 165.496 171.64C165.806 171.95 165.98 172.369 165.98 172.807Z",
    fill: "url(#paint9_linear_31_457)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M305.95 174.457C306.861 174.457 307.6 173.718 307.6 172.807C307.6 171.896 306.861 171.157 305.95 171.157C305.039 171.157 304.3 171.896 304.3 172.807C304.3 173.718 305.039 174.457 305.95 174.457Z",
    fill: "url(#paint10_linear_31_457)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M340 28.787C340 29.1133 339.903 29.4323 339.722 29.7037C339.541 29.975 339.283 30.1865 338.982 30.3114C338.68 30.4362 338.348 30.4689 338.028 30.4053C337.708 30.3416 337.414 30.1844 337.183 29.9537C336.953 29.7229 336.796 29.4289 336.732 29.1089C336.668 28.7888 336.701 28.457 336.826 28.1555C336.951 27.854 337.162 27.5963 337.433 27.415C337.705 27.2337 338.024 27.137 338.35 27.137C338.788 27.137 339.207 27.3108 339.517 27.6202C339.826 27.9297 340 28.3494 340 28.787Z",
    fill: "url(#paint11_linear_31_457)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31_457",
    x1: 188.3,
    y1: 46.427,
    x2: 188.359,
    y2: 192.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8821B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F81B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31_457",
    x1: 242.94,
    y1: 169.957,
    x2: 249.54,
    y2: 169.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3E5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29B6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_31_457",
    x1: 75.4397,
    y1: 38.8369,
    x2: 80.3897,
    y2: 38.8369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3E5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29B6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_31_457",
    x1: 362.41,
    y1: 109.577,
    x2: 365.51,
    y2: 109.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3E5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29B6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_31_457",
    x1: 0.0100007,
    y1: 92.0471,
    x2: 3.1,
    y2: 92.0471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3E5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29B6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_31_457",
    x1: 193.58,
    y1: 21.687,
    x2: 196.68,
    y2: 21.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3E5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29B6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_31_457",
    x1: 272,
    y1: 26.4871,
    x2: 275.09,
    y2: 26.4871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3E5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29B6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_31_457",
    x1: 123.02,
    y1: 24.7371,
    x2: 129.62,
    y2: 24.7371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD427E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_31_457",
    x1: 69.46,
    y1: 170.557,
    x2: 72.76,
    y2: 170.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD427E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_31_457",
    x1: 162.68,
    y1: 172.807,
    x2: 165.98,
    y2: 172.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD427E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_31_457",
    x1: 304.3,
    y1: 172.807,
    x2: 307.6,
    y2: 172.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD427E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_31_457",
    x1: 336.7,
    y1: 28.787,
    x2: 340,
    y2: 28.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD427E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA726"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg404);
export default __webpack_public_path__ + "static/media/img404.2d47e98c153ef24ccf5335df7ba370e4.svg";
export { ForwardRef as ReactComponent };